import React, { useLayoutEffect, useState } from 'react';
import styled from 'styled-components';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

import ReferenceTypeList from './ReferenceTypeList';
import { Reference } from './Reference.interface';

const StyledDialogTitle = styled(DialogTitle)`
  display: flex;
  align-items: center;
  .title {
    flex: 1;
  }
`;

export interface ReferenceTypeListDialogProps {
  type: Reference | undefined;
  onClose: () => void;
  onClickType?: (type: Reference) => void;
}

const ReferenceTypeListDialog: React.FC<ReferenceTypeListDialogProps> = (
  props: ReferenceTypeListDialogProps
) => {
  const { type, onClose, onClickType } = props;
  const [contentRef, setContentRef] = useState<HTMLElement | null>(null);

  useLayoutEffect(() => {
    if (type && contentRef) {
      contentRef.scrollTop = 0;
    }
  }, [type, contentRef]);

  return (
    <Dialog maxWidth='md' open={!!type} onClose={onClose}>
      <StyledDialogTitle disableTypography>
        <Typography variant='h6' className='title'>
          <code>{type?.typeName}</code>
        </Typography>
        <IconButton size='small' onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </StyledDialogTitle>
      <DialogContent
        style={{ padding: 0 }}
        innerRef={ref => setContentRef(ref)}
      >
        {type && (
          <ReferenceTypeList
            show
            referenceType={type}
            onClickType={onClickType}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ReferenceTypeListDialog;
